<template>
    <div class="mb-2 mr-2">
        <label class="col-form-label pt-0">{{ label }}</label>
        <div class="input-group">
            <!-- <div class="input-group-btn"> -->
            <!--     <button class="btn btn-default" type="button" title="Toggle" data-toggle> -->
            <!--         <i class="fa fa-calendar"> -->
            <!--             <span aria-hidden="true" class="sr-only">Toggle</span> -->
            <!--         </i> -->
            <!--     </button> -->
            <!-- </div> -->
            <vue-flatpickr-component
                :value="currentValue"
                :config="dpConfig"
                v-on:input="onInput"
                placeholder="Pick a date"
                class="form-control">
            </vue-flatpickr-component>
            <div class="input-group-btn">
                <button class="btn btn-default" type="button" title="Clear" data-clear>
                    <i class="fa fa-times">
                        <span aria-hidden="true" class="sr-only">Clear</span>
                    </i>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'moment';
import VueFlatpickrComponent from 'vue-flatpickr-component';

export default {
    data() {
        return {
            currentValue: null,
        }
    },

    props: ['value', 'changeFilter', 'addFilter', 'removeFilter', 'config'],

    components: {
        VueFlatpickrComponent,
    },

    created() {
        this.currentValue = this.value;
    },

    computed: {
        label() {
            const { name } = this.config;
            return `Filter by ${name}`;
        },

        field() {
            return this._.get(this.config, 'field', null);
        },

        dpConfig() {
            return _.assign({
                wrap: true,
                mode: 'range',
            }, this.config)
        },
    },

    watch: {

    },

    methods: {
        onInput(value) {
            if (!value) {
                this.removeFilter(this.field);
                return this.changeFilter();
            }

            const range = _.chain(value)
                .split(' to ')
                .filter()
                .value();

            const [min, max] = range;

            if (!min || !max) return;

            this.$emit('input', range);

            const dateMin = min ? M(min).format('YYYY-MM-DD') : '';
            const dateMax = max ? M(max).add(1, 'days').format('YYYY-MM-DD') : '';
            this.changeFilter(this.field, `$range(${dateMin},${dateMax})`);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/DateFilterComponent.vue